import React, { useEffect } from "react";

const EnterButton = ({ buttonName, onClickAction }) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      document.getElementById("dynamicButton").click(); // Trigger button click
    }
  };

  useEffect(() => {
    // Add the event listener for the Enter key
    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <button
      id="dynamicButton"
      onClick={onClickAction}
      className="btn btn-primary"
    >
      {buttonName}
    </button>
  );
};

export default EnterButton;
